<template>
  <section>
    <v-card>
      <v-card-text>
        <v-layout wrap>
        <v-flex xs12>
          <v-card>
            <v-card-text>
              <v-layout wrap>
                <v-flex xs8>
                  {{caso.descripcion}}
                </v-flex>
                <v-flex xs4>
                  <strong>Tipo</strong> {{ caso.tipo }}<br>
                  <strong>Estado</strong> {{ caso.estado }}
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12>
          <div class="conversation-container" id="conversation" style="padding: 5px;">
            <div v-for="(mensaje, idx) in mensajes" :key="idx">
              <span v-if="mensaje.direccion == 'AVISO'" class="aviso">
                <span class="aviso-message" v-html="mensaje.contenido">{{mensaje.contenido}}</span>
              </span>
              <div v-if="mensaje.direccion != 'AVISO'" v-bind:class="{'message':true, 'sent':(mensaje.direccion === 'SALIDA')}">
                <span v-if="mensaje.tipo_contenido == 'texto'" style="white-space:pre-wrap;">{{mensaje.contenido}}</span>
                <span v-if="mensaje.tipo_contenido == 'email'">
                  <span v-if="mensaje.extras && mensaje.extras.asunto"><strong>{{mensaje.extras.asunto}}</strong><br></span>
                  <span v-if="mensaje.extras && mensaje.extras.remitente">De: {{mensaje.extras.remitente}}<br></span>
                  <span v-html="mensaje.contenido"></span>
                  <span v-if="mensaje.extras && mensaje.extras.adjuntos && mensaje.extras.adjuntos.length > 0"><hr/>Adjuntos</span>
                  <div v-if="mensaje.extras && mensaje.extras.adjuntos && mensaje.extras.adjuntos.length > 0">
                    <span v-for="(adjunto, ax) in mensaje.extras.adjuntos" :key="ax" class="message-chip">{{adjunto.nombre}}</span>
                    <file-viewer :caso="mensaje.id_caso" :msg_id="mensaje.msg_id" :extras="{}" file="" mime="application/zip"></file-viewer>
                  </div>
                </span>
                <span v-if="mensaje.extras" class="nombre-archivo">
                  <span v-if="mensaje.extras.nombre">{{mensaje.extras.nombre}}</span><span v-if="mensaje.extras.tamanio">{{mensaje.extras.tamanio}}</span>
                </span>
                <span v-if="mensaje.tipo_contenido == 'imagen'"><imagen-viewer :caso="mensaje.id_caso" :msg_id="mensaje.msg_id" :extras="mensaje.extras" :file="mensaje.contenido" :mime="mensaje.mime_type"></imagen-viewer></span>
                  <audio-player v-if="mensaje.tipo_contenido == 'audio'" :caso="mensaje.id_caso" :msg_id="mensaje.msg_id" :extras="mensaje.extras" :file="mensaje.contenido" :mime="mensaje.mime_type" :muteButton="true" :downloadButton="true"></audio-player>
                  <video-player v-if="mensaje.tipo_contenido == 'video'" :caso="mensaje.id_caso" :msg_id="mensaje.msg_id" :extras="mensaje.extras" :file="mensaje.contenido" :mime="mensaje.mime_type" :muteButton="true" :downloadButton="true" :fullscreenButton="true"></video-player>
                  <file-viewer v-if="mensaje.tipo_contenido == 'archivo'" :caso="mensaje.id_caso" :msg_id="mensaje.msg_id" :extras="mensaje.extras" :file="mensaje.contenido" :mime="mensaje.mime_type"></file-viewer>
                <span class="metadata">
                    <span class="time">{{formato(mensaje)}}&nbsp;</span>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <img v-on="on" :src="imagenCanal(mensaje['canal_entrada.clasificacion'])" class="icono-canal" align="right"/>
                      </template>
                      <!--span class="tick" v-if="mensaje.direccion == 'SALIDA'"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" id="msg-dblcheck-ack" x="2063" y="2076"><path d="M15.01 3.316l-.478-.372a.365.365 0 0 0-.51.063L8.666 9.88a.32.32 0 0 1-.484.032l-.358-.325a.32.32 0 0 0-.484.032l-.378.48a.418.418 0 0 0 .036.54l1.32 1.267a.32.32 0 0 0 .484-.034l6.272-8.048a.366.366 0 0 0-.064-.512zm-4.1 0l-.478-.372a.365.365 0 0 0-.51.063L4.566 9.88a.32.32 0 0 1-.484.032L1.892 7.77a.366.366 0 0 0-.516.005l-.423.433a.364.364 0 0 0 .006.514l3.255 3.185a.32.32 0 0 0 .484-.033l6.272-8.048a.365.365 0 0 0-.063-.51z" fill="#4fc3f7"/></svg></span-->
                      <span>{{mensaje['canal_entrada.usuario']}}</span>
                    </v-tooltip>
                  </span>
                </span>
              </div>
            </div>
          </div>
        </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import AudioPlayer from '@/common/plugins/audio/Audio';
import ImagenViewer from '@/common/plugins/imagen/Imagen';
import VideoPlayer from '@/common/plugins/video/Video';
import FileViewer from '@/common/plugins/file/File.vue';
import moment from 'moment';
export default {
  props: ['caso'],
  watch: {},
  created () {},
  mounted () {
    this.$nextTick(() => {
      this.recuperarCaso();
    });
  },
  data () {
    return {
      mensajes: []
    };
  },
  beforeCreate () {},
  computed: {},
  methods: {
    imagenCanal (clasificacion) {
      let imagen = 'call.png';
      switch (clasificacion) {
        case 'whatsapp':
          imagen = 'wp.png';
          break;
        case 'facebook':
          imagen = 'fb.png';
          break;
        case 'twitter':
          imagen = 'tw.png';
          break;
        case 'correo':
          imagen = 'mail.png';
          break;
      }
      return require('@/assets/images/' + imagen);
    },
    formato (mensaje) {
      if (mensaje.msg_tz) {
        let fecha = mensaje.msg_tz.substr(0, 10) * 1000;
        var date = moment(fecha).format('DD/MM/YYYY HH:mm:ss');
        return date;
      } else {
        return moment(mensaje._created_at).format('DD/MM/YYYY HH:mm:ss');
      }
    },
    recuperarCaso () {
      if (this.caso.id) {
        this.$service.get(`system/operadores/caso/${this.caso.id}/mensajes`, {})
        .then(response => {
          this.mensajes = [];
          if (response && response.rows) {
            this.mensajes = response.rows;
            this.mensajes.sort((a, b) => {
              if (a.msg_tz && b.msg_tz) {
                return a.msg_tz.substr(0, 10) - b.msg_tz.substr(0, 10);
              }
              return a.id - b.id;
            });
          }
        });
      }
    }
  },
  components: {moment, AudioPlayer, VideoPlayer, ImagenViewer, FileViewer}
};
</script>
<style src="./chat.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/components/admin/operadores/CasoResumen.vue